import { Popover, Tooltip } from '@game/ui';
import type { JSX } from 'react';
import { useMedia } from 'react-use';

import { breakpoints } from '@constants/breakpoints';

import type { LoreDictionaryKey } from './LoreDictionary';
import { loreDictionary } from './LoreDictionary';

import './LoreToolTip.less';

interface LoreTooltipProps {
  text: string;
  title: string;
}

export const LoreTooltip = ({ text, title }: LoreTooltipProps): JSX.Element => {
  const isDesktop = useMedia(`(min-width: ${breakpoints.md}px)`);

  if (isDesktop) {
    return (
      <Tooltip className="lore-tooltip" title={text}>
        <span className="lore-tooltip-text">{title}</span>
      </Tooltip>
    );
  }

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button className="lore-tooltip-button">{title}</button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content align="center" side="top" className="lore-tooltip-popover-content">
          {text}
          <Popover.Arrow className="lore-tooltip-popover-arrow" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

interface LoreTooltipFromDictionaryProps {
  dictionaryKey: LoreDictionaryKey;
}

export const LoreTooltipFromDictionary = ({ dictionaryKey }: LoreTooltipFromDictionaryProps): JSX.Element => {
  const lore = loreDictionary[dictionaryKey];
  return <LoreTooltip text={lore} title={dictionaryKey} />;
};
